import router from "@/router";

const state = {
	rawHash: ''
}

const getters = {
	urlHash(state) {
		const rh = state.rawHash.slice(1).split('&');
		let o = {};

		rh.map((i) => {
			const item = i.split('=');
			o[item[0]] = item[1];
		})

		return o;
	},
	isDeepLink(){
		const route = router.currentRoute;
		const queries = [
			'searchTerm',
			'category',
			'saving',
			'waysToSave'
		];
		const hashes = [
			'sku',
			'page',
			'index'
		];

		for(let query of queries) {
			if(route?.query[query]) return true;
		}

		for(let hash of hashes) {
			if(route?.hash?.includes(`${hash}=`))return true;
		}

		return false;
	}
}

const actions = {
	updateHash({commit}, hash) {
		commit('UPDATE_HASH', hash);
	},

	findPageWithSku({rootState}, sku) {
		const pages = rootState.pages || [];
		return pages.find((page) => {
			return page.blocks.find((block) => {
				return block.products.find((product) => {
					return product.sku === sku;
				})
			})
		})
	}
}

const mutations = {
	UPDATE_HASH(state, hash) {
		state.rawHash = hash
	}
}


export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
}
